import React, { useState } from 'react'

import { List, Button } from 'antd'
import { useHistory } from 'react-router-dom'

import Profile from '../../../../core/components/profile'
import { getGroupNameFromType } from '../../../../config/const'
import { useFetch, useCreateEventNotAvailable, useDismissEvent } from '../../../../hooks/manager/user'

import { ImportOutlined } from '@ant-design/icons'

import BannerNotAvailable from '../../../../components/event/banner/notAvailable'
import FormNotAvailable from '../../../../components/event/form/notAvailableV2'
import ManagerInformation from './information'

import Loader from '../../../../components/loader'

const Show = () => {
  const history = useHistory()
  const goBack = () => history.goBack()

  const { data, isLoading, isError } = useFetch()
  const { mutate: createEventNotAvailable, isLoading: isCreateEventLoading } = useCreateEventNotAvailable()
  const { mutate: dismissEvent, isLoading: isDismissEventLoading } = useDismissEvent()

  const actionLoading = isCreateEventLoading || isDismissEventLoading

  const [modalVisible, setModalVisible] = useState(false)
  const showModal = () => setModalVisible(true)
  const hideModal = () => setModalVisible(false)

  if (isLoading) {
    return (<Loader loading />)
  }
  if (isError) {
    return null
  }

  const { manager, events } = data

  return (
    <>
      <BannerNotAvailable manager events={events || []} dismissEvent={dismissEvent} />
      <Profile
        onBack={goBack}
        mainTitle='Settings'
        ainSubtitle='subtitle'
        mainExtra={[
          <Button key='ooo' type='default' size='small' icon={<ImportOutlined />} onClick={showModal}>
            Not Available
          </Button>
        ]}
        renderInformation={() => <ManagerInformation manager={manager} />}
      >
        <h2 className='after-underline'>Groups</h2>
        <List
          dataSource={manager.groups || []}
          renderItem={(item) => <List.Item className='skill-item'>{getGroupNameFromType(item)}</List.Item>}
        />

        {modalVisible && (
          <FormNotAvailable
            createEventNotAvailable={createEventNotAvailable}
            onCancel={hideModal}
            modalVisible={modalVisible}
          />
        )}
      </Profile>
    </>
  )
}

export default Show
